import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/App/Button';

import addDiscoverSuccessImage from 'assets/images/create-discover-success.png';
import styles from './AddDiscoverySuccess.module.scss';

function AddDiscoverySuccess({ placeName, slug, onViewOnBookese, onManage }) {
  const subtitle = placeName
    ? `Quản lý, chỉnh sửa điểm khám phá ${placeName} ngay`
    : 'Quản lý, chỉnh sửa điểm khám phá ngay';

  const handleViewOnBookese = (e) => {
    if (onViewOnBookese) {
      onViewOnBookese(e);
    }
    const baseUrl = (process.env.REACT_APP_BOOKESE_URL || 'https://bookese.com').replace(/\/$/, '');
    let targetUrl = baseUrl;
    if (slug) {
      const cleanSlug = slug.startsWith('/') ? slug : `/explore/details/${slug}`;
      targetUrl = `${baseUrl}${cleanSlug}`;
    } else {
      targetUrl = `${baseUrl}/explore/details`;
    }
    window.open(targetUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className={styles.Component}>
        <div className={styles.TextGroup}>
          <h2 className={styles.Title}>Điểm khám phá khởi tạo thành công!</h2>
          <p className={styles.Description}>{subtitle}</p>
        </div>

        <div>
          <img
            src={addDiscoverSuccessImage}
            alt="Discovery success illustration"
            className={styles.Illustration}
          />

          <div className={styles.Actions}>
            <button
              type="button"
              className={styles.ViewLink}
              onClick={handleViewOnBookese}
            >
              Xem trên Bookese.com
            </button>

            <Button
              classes={styles.ManageButton}
              onClick={onManage}
            >
              Quản lý
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

AddDiscoverySuccess.propTypes = {
  placeName: PropTypes.string,
  slug: PropTypes.string,
  onViewOnBookese: PropTypes.func,
  onManage: PropTypes.func,
};

AddDiscoverySuccess.defaultProps = {
  placeName: '',
  slug: '',
  onViewOnBookese: () => { },
  onManage: () => { },
};

export default AddDiscoverySuccess;
